import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "top-matter" }
const _hoisted_2 = { class: "right-actions" }

import { computed, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import NcBreadcrumbs from '@nextcloud/vue/components/NcBreadcrumbs';
import NcBreadcrumb from '@nextcloud/vue/components/NcBreadcrumb';
import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';
import PublicUploadHandler from '@components/upload/PublicUploadHandler.vue';

import { t } from '@services/l10n';
import { useRouteIs } from '@services/route-is';
import { config } from '@services/user-config';
import * as utils from '@services/utils/common';
import initstate from '@services/init-state';

import HomeIcon from 'vue-material-design-icons/Home.vue';
import ShareIcon from 'vue-material-design-icons/ShareVariant.vue';
import TimelineIcon from 'vue-material-design-icons/ImageMultiple.vue';
import FoldersIcon from 'vue-material-design-icons/FolderMultiple.vue';
import UploadIcon from 'vue-material-design-icons/Upload.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FolderTopMatter',
},
  __name: 'FolderTopMatter',
  setup(__props) {



const route = useRoute();
const router = useRouter();
const routeIs = useRouteIs();
const uploadHandler = useTemplateRef<InstanceType<typeof PublicUploadHandler>>('uploadHandler');

const list = computed(
  (): {
    text: string;
    path: string[];
    idx: number;
  }[] => {
    let path: string[] | string = route.params.path || '';
    if (typeof path === 'string') {
      path = path.split('/');
    }

    return path
      .filter(Boolean) // non-empty
      .map((text, idx, arr) => {
        const path = arr.slice(0, idx + 1);
        return { text, path, idx };
      });
  },
);

const recursive = computed((): boolean => {
  return !!route.query.recursive;
});

const rootFolderName = computed((): string => {
  return routeIs.Public ? initstate.shareTitle : t('memories', 'Home');
});

const allowPublicUpload = computed((): boolean => {
  return routeIs.Public && initstate.allow_upload === true;
});

function share(): void {
  _m.modals.shareNodeLink(utils.getFolderRoutePath(config.folders_path, { route }));
}

function upload(): void {
  _m.modals.upload();
}

function toggleRecursive(): void {
  router.replace({
    query: {
      ...router.currentRoute.value.query,
      recursive: recursive.value ? undefined : String(1),
    },
  });
}

function getRoute(path: string[]): object {
  return {
    name: route.name,
    params: { ...route.params, path },
    query: route.query,
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_unref(NcBreadcrumbs), {
      key: _unref(route).path
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NcBreadcrumb), {
          name: rootFolderName.value,
          to: getRoute([]),
          "force-icon-text": _unref(routeIs).Public
        }, {
          icon: _withCtx(() => [
            (_unref(routeIs).Public)
              ? (_openBlock(), _createBlock(ShareIcon, {
                  key: 0,
                  size: 20
                }))
              : (_openBlock(), _createBlock(HomeIcon, {
                  key: 1,
                  size: 20
                }))
          ]),
          _: 1
        }, 8, ["name", "to", "force-icon-text"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (folder) => {
          return (_openBlock(), _createBlock(_unref(NcBreadcrumb), {
            key: folder.idx,
            name: folder.text,
            to: getRoute(folder.path)
          }, null, 8, ["name", "to"]))
        }), 128))
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_2, [
      (allowPublicUpload.value)
        ? (_openBlock(), _createBlock(PublicUploadHandler, {
            key: 0,
            ref_key: "uploadHandler",
            ref: uploadHandler
          }, null, 512))
        : _createCommentVNode("", true),
      _createVNode(_unref(NcActions), { inline: 3 }, {
        default: _withCtx(() => [
          (!_unref(routeIs).Public)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 0,
                "aria-label": _unref(t)('memories', 'Share folder'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (share())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(ShareIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Share folder')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          (!_unref(routeIs).Public)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 1,
                "aria-label": _unref(t)('memories', 'Upload files'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (upload())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(UploadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Upload files')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          (allowPublicUpload.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 2,
                "aria-label": _unref(t)('memories', 'Upload files'),
                disabled: uploadHandler.value?.processing,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (uploadHandler.value?.startUpload()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(UploadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Upload files')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NcActionButton), {
            onClick: toggleRecursive,
            "close-after-click": ""
          }, {
            icon: _withCtx(() => [
              (recursive.value)
                ? (_openBlock(), _createBlock(FoldersIcon, {
                    key: 0,
                    size: 20
                  }))
                : (_openBlock(), _createBlock(TimelineIcon, {
                    key: 1,
                    size: 20
                  }))
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(recursive.value ? _unref(t)('memories', 'Folder view') : _unref(t)('memories', 'Timeline view')) + " ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})